export enum LogLevel {
    DEBUG,
    INFO,
    ERROR,
}
